import { Component, EventEmitter, Output } from '@angular/core';
import { PagamentoForm } from '../../../form/pagamento-form';


import { SezionePagamentiResponse } from '../../../models/dto/sezione-pagamenti-response';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { Pagamento } from '../../../models/pagamento';

import { SezionePagamenti } from '../../../models/sezioni/sezione-pagamenti';


@Component({
    selector: 'div [pagamento-form-edit]',
  templateUrl: '../../../form/pagamento-form.html'
})

export class PagamentiEditComponent extends PagamentoForm {
  pagamento: Pagamento;
  sezione: SezionePagamenti;
  urlUpdate: string;
  urlReadSezioneAltreParti: string;
  urlReadSezioneControparti: string;
  urlReadSezioneLegali: string;

  @Output() onReturn: EventEmitter<SezionePagamenti> = new EventEmitter<SezionePagamenti>();

  ngOnInit() {
    this.setTitle('Modifica Pagamento');
    this.isInserimento(false);
  }

  getPagamento() {
    return this.pagamento;
  }

  getUrlReadSezioneAltreParti() {
    return this.urlReadSezioneAltreParti;
  }

  getUrlReadSezioneControparti() {
    return this.urlReadSezioneControparti;
  }

  getUrlReadSezioneLegali() {
    return this.urlReadSezioneLegali;
  }

  getRequest(pagamento: Pagamento) {
    this.operationService.updatePagamento(this.urlUpdate, pagamento, this.sezione.id).subscribe((response: any) => this.datiPagamento(response));
  }

  datiPagamento(response: SezionePagamentiResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(sezione: SezionePagamenti, pagamento: Pagamento, fascicolo: FascicoloFull, urlUpdate: string, urlReadSezioneAltreParti: string, urlReadSezioneControparti: string, urlReadSezioneLegali: string) {
    this.pagamento = pagamento;
    this.sezione = sezione;
    this.urlUpdate = urlUpdate;
    this.urlReadSezioneAltreParti = urlReadSezioneAltreParti;
    this.urlReadSezioneControparti = urlReadSezioneControparti;
    this.urlReadSezioneLegali = urlReadSezioneLegali;
    this.createForm();
    if (this.sections.altreParti && this.sections.controparti && this.sections.legali) {
      this.populateSelect();
    } else {
      this.beneficiariAll = [];
      this.readSezioneAltreParti(fascicolo.idSezioneAltreParti);
      this.readSezioneControparti(fascicolo.idSezioneControparti);
      this.readSezioneLegali(fascicolo.idSezioneLegali);
    }
  }
}
